import { render, staticRenderFns } from "./newOaWorkflowPool.vue?vue&type=template&id=fbe5c4ce&scoped=true"
import script from "./newOaWorkflowPool.vue?vue&type=script&lang=js"
export * from "./newOaWorkflowPool.vue?vue&type=script&lang=js"
import style0 from "./newOaWorkflowPool.vue?vue&type=style&index=0&id=fbe5c4ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbe5c4ce",
  null
  
)

export default component.exports